<template>
    <div class="container-fluid-grid">
        <div class="form-row">
            <div class="col-md-4 form-group">
                <label for="proposalEditName" class="required">Vendedor</label>
                <Autocomplete id="proposalEditName"
                              v-if="entity.seller"
                              v-model="entity.seller.name"
                              placeholder="Informe o nome do vendedor"
                              url="/v1/proposals/search/customers?criteria="
                              :input-class="['form-control form-control-sm', {'is-invalid': errors.seller_id}]"
                              :on-select-item="val => returnValue(val, true)"
                              :item-value-presentation="itemValuePresentation"
                              :item-presentation="itemPresentation"/>
                <field-messages :errors="errors.seller_id"/>

                <transition name="fade" v-if="$appUtils.isMobile()">
                    <CustomerDetail :customer="entity.seller"  v-if="entity.seller_id"/>
                </transition>
            </div>
            <div class="col-md-2 form-group">
                <label for="proposalEditSellerContact" class="required">Contato</label>
                <input type="text" id="proposalEditSellerContact"
                       :class="{'is-invalid': errors['seller_contact']}"
                       class="form-control form-control-sm"
                       v-model="entity.seller_contact"/>
                <field-messages :errors="errors.seller_contact"/>
            </div>
            <div class="col-4 col-md-2 form-group">
                <label>Requer assinatura?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label>
                        <input type="checkbox"
                               v-model="entity.is_seller_require_assign"
                               @change="() => {
                                        entity.is_assign_seller = false;
                                        entity.assign_seller_at = null;
                                      }"
                               class="checkbox green m"/></label>
                </div>
            </div>
            <div class="col-4 col-md-2 form-group">
                <label>Vendedor assinou?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  :disabled="!entity.is_seller_require_assign"
                                  v-model="entity.is_assign_seller"
                                  @change="entity.assign_seller_at = null"
                                  class="checkbox green m"/></label>
                </div>
            </div>
            <div class="col-4 col-md-2 form-group">
                <label for="proposalEditAssignSellerAt" :class="{required: entity.is_assign_seller}">Data assinatura</label>
                <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalEditAssignSellerAt"
                           :disabled="!entity.is_assign_seller"
                           :key="entity.is_assign_seller"
                           :required="entity.is_assign_seller"
                           :class="{'is-invalid': errors.assign_seller_at}"
                           v-model="entity.assign_seller_at"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           v-mask="'##/##/####'"
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <svg-icon icon="calendar-alt"/>
                        </div>
                    </div>
                </div>
                <field-messages :errors="errors.assign_seller_at"/>
            </div>
        </div>
        <transition name="fade" v-if="!$appUtils.isMobile()">
            <CustomerDetail :customer="entity.seller"  v-if="entity.seller_id > 0"/>
        </transition>
        <hr>
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="proposalEditBuyerName" class="required">Comprador</label>
                <Autocomplete id="proposalEditBuyerName"
                              v-if="entity.buyer"
                              v-model="entity.buyer.name"
                              placeholder="Informe o nome do comprador"
                              url="/v1/proposals/search/customers?criteria="
                              :input-class="['form-control form-control-sm', {'is-invalid': errors['buyer_id']}]"
                              :on-select-item="val => returnValue(val, false)"
                              :item-value-presentation="itemValuePresentation"
                              :item-presentation="itemPresentation"/>
                <field-messages :errors="errors['buyer_id']"/>

                <transition name="fade" v-if="$appUtils.isMobile()">
                    <CustomerDetail :customer="entity.buyer"  v-if="entity.buyer_id"/>
                </transition>
            </div>
            <div class="form-group col-md-2">
                <label for="proposalEditBuyerContact" class="required">Contato</label>
                <input type="text" id="proposalEditBuyerContact"
                       :class="{'is-invalid': errors['buyer_contact']}"
                       class="form-control form-control-sm"
                       v-model="entity.buyer_contact"/>
                <field-messages :errors="errors.buyer_contact"/>
            </div>
            <div class="col-4 form-group col-md-2">
                <label>Requer assinatura?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  v-model="entity.is_buyer_require_assign"
                                  @change="() => {
                                    entity.is_assign_buyer = false;
                                    entity.assign_buyer_at = null;
                                  }"
                                  class="checkbox green m"/></label>
                </div>
            </div>
            <div class="col-4 form-group col-md-2">
                <label>Vendedor assinou?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  :disabled="!entity.is_buyer_require_assign"
                                  v-model="entity.is_assign_buyer"
                                  @click="entity.assign_buyer_at = null"
                                  class="checkbox green m"/></label>
                </div>
            </div>
            <div class="col-4 form-group col-md-2">
                <label for="proposalEditIsAssignBuyer" :class="{required: entity.is_assign_buyer}">Data assinatura</label>
                <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalEditIsAssignBuyer"
                           :disabled="!entity.is_assign_buyer"
                           :required="entity.is_assign_buyer"
                           v-model="entity.assign_buyer_at"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           v-mask="'##/##/####'"
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <svg-icon icon="calendar-alt"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade" v-if="!$appUtils.isMobile()">
            <CustomerDetail :customer="entity.buyer" v-if="entity.buyer_id"/>
        </transition>

        <div class="form-row">
            <div class="form-group col-md-2">
                <label for="proposalEditProduct" class="required">Produto</label>
                <select id="proposalEditProduct"
                        @change="changeProduct"
                        :class="{'is-invalid': errors['product_id']}"
                        required
                        class="form-control form-control-sm"
                        v-model="entity.product_id">
                    <optgroup v-for="c in categories" :label="c.name">
                        <option v-for="p in products"
                                v-if="p.product_category_id === c.id"
                                :key="p.id"
                                :value="p.id">{{p.name}}</option>
                    </optgroup>
                </select>
                <field-messages :errors="errors.product_id"/>
            </div>
            <div class="form-group col-md-1">
                <label for="proposalEditHarvest" class="required">Safra</label>
                <select id="proposalEditHarvest"
                        required
                        :class="{'is-invalid': errors['harvest']}"
                        class="form-control form-control-sm"
                        v-model="entity.harvest">
                    <option v-for="h in harvests"
                            :key="h.year"
                            :disabled="h.disabled"
                            :value="h.year">{{h.year}}</option>
                </select>
                <field-messages :errors="errors.harvest"/>
            </div>
            <div class="form-group col-md-1">
                <label for="proposalEditFreightType" class="required">Frete</label>
                <select id="proposalEditFreightType"
                        required
                        :class="{'is-invalid': errors.harvest}"
                        class="form-control form-control-sm"
                        v-model="entity.freight_type">
                    <option v-for="ft in freight_types"
                            :key="ft.code"
                            :value="ft.code">{{ft.label}}</option>

                </select>
                <field-messages :errors="errors.freight_type"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label>Modalidade preço</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  v-model="price_type"
                                  @change="() => {
                                    entity.price_type = `value_${price_type ? '' : 'un'}defined`;
                                    entity.price = null;
                                    if (!entity.id) entity.price_description = '';
                                  }"
                                  class="checkbox green m"/> <span class="c-theme f-w-400">{{ price_type ? 'Definido' : 'A Fixar' }}</span></label>
                </div>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditPrice" :class="{required: price_type}">Preço</label>
                <input type="text"
                       id="proposalEditPrice"
                       :class="{'is-invalid': errors.price}"
                       :disabled="!price_type"
                       :required="price_type"
                       autocomplete="off"
                       @blur="priceBlur"
                       v-money="{precision: 2, decimal: ',', thousands: '.'}"
                       class="form-control form-control-sm t-r"
                       v-model="entity.price"/>
                <field-messages :errors="errors.price"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditQtd" class="required">Quantidade</label>
                <input type="text"
                       id="proposalEditQtd"
                       :class="{'is-invalid': errors.quantity}"
                       :disabled="$appStorage.getUser().profile !== 'admin_all' && entity.id > 0"
                       @blur="quantityBlur"
                       autocomplete="off"
                       v-money="{precision: 3, decimal: ',', thousands: ''}"
                       class="form-control form-control-sm t-r"
                       v-model="entity.quantity"/>
                <field-messages :errors="errors.quantity"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditQtdEmb">Qtd. Embarcada</label>
                <input type="text"
                       id="proposalEditQtdEmb"
                       :class="{'is-invalid': errors.quantity_embedded}"
                       autocomplete="off"
                       v-money="{precision: 3, decimal: ',', thousands: ''}"
                       class="form-control form-control-sm t-r"
                       v-model="entity.quantity_embedded"/>
                <field-messages :errors="errors.quantity_embedded"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-lg-6 col-md-6">
                <label for="proposalEditQtdDesc" class="required">Quantidade/Descrição</label>
                <textarea id="proposalEditQtdDesc"
                          class="form-control form-control-sm"
                          rows="7"
                          required
                          :class="{'is-invalid': errors.description}"
                          v-model="entity.description"></textarea>
                <field-messages :errors="errors.description"/>
            </div>
            <div class="form-group col-lg-6 col-md-6">
                <label for="proposalEditPriceDesc" :class="{required: price_type }">Preço/Descrição</label>
                <textarea id="proposalEditPriceDesc"
                          maxlength="4000"
                          rows="7"
                          class="form-control form-control-sm"
                          :required="price_type"
                          :class="{'is-invalid': errors.price_description}"
                          v-model="entity.price_description"></textarea>
                <field-messages :errors="errors.price_description"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="proposalEditShipmentType" class="required">Embarque</label>
                <input type="text"
                       maxlength="1000"
                       id="proposalEditShipmentType"
                       :class="{'is-invalid': errors.shipment_type}"
                       class="form-control form-control-sm"
                       v-model="entity.shipment_type"/>
                <field-messages :errors="errors.shipment_type"/>
            </div>
            <div class="form-group col-md-2">
                <label for="proposalEditPaymentDate">Pagamento fixo</label>
                <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalEditPaymentDate"
                           v-model="entity.payment_date"
                           placeholder="DD/MM/AAAA"
                           :class="{'is-invalid': errors.payment_date}"
                           @blur="defineBillingDate"
                           v-flatpickr
                           v-mask="'##/##/####'"
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <svg-icon icon="calendar-alt"/>
                        </div>
                    </div>
                </div>
                <field-messages :errors="errors.payment_date"/>
            </div>
            <div class="form-group col-md-2">
                <label for="proposalEditBillingDate" class="required">Faturar em</label>
                <div class="input-group input-group-sm">
                    <input type="text"
                           id="proposalEditBillingDate"
                           required
                           v-model="entity.billing_date"
                           placeholder="DD/MM/AAAA"
                           :class="{'is-invalid': errors.billing_date}"
                           v-flatpickr
                           v-mask="'##/##/####'"
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <svg-icon icon="calendar-alt"/>
                        </div>
                    </div>
                </div>
                <field-messages :errors="errors.billing_date"/>
            </div>
            <div class="form-group col-md-4">
                <label for="proposalEditPaymentType" class="required">Pagamento</label>
                <input type="text"
                       id="proposalEditPaymentType"
                       :class="{'is-invalid': errors.payment_type}"
                       class="form-control form-control-sm"
                       autocomplete="off"
                       list="payment_type_list"
                       v-model="entity.payment_type"/>
                <field-messages :errors="errors.payment_type"/>
                <datalist id="payment_type_list">
                    <option v-for="pt in seller_accounts" :title="`REMESSA VIA ${pt.bank_name} AGÊNCIA (${pt.agency}) CONTA CORRENTE Nº ${pt.number} CNPJ ${$appUtils.formatDocument(pt.document)}`">
                        REMESSA VIA {{pt.bank_name}} AGÊNCIA ({{pt.agency}}) CONTA CORRENTE Nº {{pt.number}} CNPJ {{pt.document | formatDocument}}
                    </option>
                </datalist>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12">
                <label for="proposalEditSpecialConditions">Condições Especiais</label>
                <textarea id="proposalEditSpecialConditions"
                          class="form-control form-control-sm"
                          :class="{'is-invalid': errors.special_condition}"
                          v-model="entity.special_condition"></textarea>
                <field-messages :errors="errors.special_condition"/>
            </div>
        </div>
        <hr>
        <div class="form-row">
            <div class="col-6 form-group col-md-2">
                <label>Gera comissão?</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  :disabled="!isAdmin"
                                  @change="changeBillable"
                                  v-model="entity.is_billable"
                                  class="checkbox green m"/> <span :class="{'c-theme': isAdmin, 'c-theme-disabled': !isAdmin}" class=" f-w-400">{{entity.is_billable ? 'Sim' : 'Não'}}</span></label>
                </div>
            </div>
            <div class="col-6 form-group col-md-2">
                <label>Tipo comissão</label>
                <div class="checkbox-inline" style="padding: 5px">
                    <label><input type="checkbox"
                                  v-model="entity.value_or_percent_commission"
                                  :disabled="!entity.is_billable"
                                  @change="() => {entity.percentage_commission = null; entity.value_commission = null}"
                                  class="checkbox green m"/> <span class="c-theme f-w-400">{{entity.value_or_percent_commission ? 'Valor Fixo' : 'Percentual'}}</span></label>
                </div>
            </div>
            <div class="col-6 form-group col-md-2">
                <transition name="fade">
                <div v-if="entity.value_or_percent_commission">
                    <label for="proposalEditValueCommission"
                           :class="{required: entity.is_billable}">Valor fixo</label>
                    <input type="text"
                           id="proposalEditValueCommission"
                           :class="{'is-invalid': errors.value_commission}"
                           v-money="{precision: 2, decimal: ',', thousands: '.'}"
                           :disabled="!entity.is_billable"
                           class="form-control form-control-sm t-r"
                           v-model="entity.value_commission"/>
                    <field-messages :errors="errors.value_commission"/>
                </div>
                <div v-else>
                    <label for="proposalEditPercentCommission"
                           :class="{required: entity.is_billable}">Percentual</label>
                    <input type="text"
                           id="proposalEditPercentCommission"
                           :class="{'is-invalid': errors.percentage_commission}"
                           maxlength="5"
                           v-money="{precision: 2, decimal: ',', thousands: ''}"
                           :disabled="!entity.is_billable"
                           placeholder="Ex: 1,5"
                           class="form-control form-control-sm t-r"
                           v-model="entity.percentage_commission"/>
                    <field-messages :errors="errors.percentage_commission"/>
                </div>
                </transition>
            </div>
            <div class="form-group col-md-6">
                <label for="proposalEditCommission" :class="{required: entity.is_billable}">Comissão</label>
                <input type="text"
                       id="proposalEditCommission"
                       :class="{'is-invalid': errors.commission}"
                       :required="entity.is_billable"
                       :disabled="!entity.is_billable"
                       class="form-control form-control-sm"
                       v-model="entity.commission"/>
                <field-messages :errors="errors.commission"/>
            </div>
        </div>
        <div class="form-row">
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerOne"
                       :class="{required: entity.is_billable}">Corretor Vendedor</label>
                <select id="proposalEditBrokerOne"
                        :required="entity.is_billable"
                        :disabled="!entity.is_billable || (!isAdmin && !!entity.id)"
                        :class="{'is-invalid': errors.broker_one_id}"
                        :key="entity.broker_one_id"
                        class="form-control form-control-sm"
                        v-model="entity.broker_one_id">
                    <option :value="null" v-if="!entity.is_billable">[SELECIONE]</option>
                    <option v-for="b in brokers"
                            :key="b.id"
                            :disabled="b.removed"
                            :value="b.id">{{b.name}} {{b.last_name}}</option>
                </select>
                <field-messages :errors="errors.broker_one_id"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerOneCommission"
                       :class="{required: entity.is_billable}">Comissão Vendedor</label>
                <input type="text"
                       id="proposalEditBrokerOneCommission"
                       :class="{'is-invalid': errors.broker_one_commission}"
                       maxlength="5"
                       v-money="{precision: 1, decimal: ',', thousands: ''}"
                       :required="entity.is_billable"
                       :disabled="!entity.is_billable || (!isAdmin && !!entity.id)"
                       class="form-control form-control-sm t-r"
                       v-model="entity.broker_one_commission"/>
                <field-messages :errors="errors.broker_one_commission"/>
            </div>

            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerTwo">Corretor Comprador</label>
                <select id="proposalEditBrokerTwo"
                        :disabled="!entity.is_billable || !entity.broker_one_id || (!isAdmin && !!entity.id)"
                        :class="{'is-invalid': errors.broker_two_id}"
                        @change="entity.broker_two_commission = null"
                        class="form-control form-control-sm"
                        v-model="entity.broker_two_id">
                    <option :value="null">[SELECIONE]</option>
                    <option v-for="b in brokers"
                            :key="b.id"
                            :disabled="b.removed || b.id === entity.broker_one_id"
                            :value="b.id">{{b.name}} {{b.last_name}}</option>
                </select>
                <field-messages :errors="errors.broker_two_id"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerTwoCommission" :class="{required: !!entity.broker_two_id}">Comissão Comprador</label>
                <input type="text"
                       id="proposalEditBrokerTwoCommission"
                       :class="{'is-invalid': errors.broker_two_commission}"
                       maxlength="5"
                       v-money="{precision: 1, decimal: ',', thousands: ''}"
                       placeholder="Ex: 20,0"
                       :disabled="!entity.is_billable || !entity.broker_two_id"
                       class="form-control form-control-sm t-r"
                       v-model="entity.broker_two_commission"/>
                <field-messages :errors="errors.broker_two_commission"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerThree">3º Corretor</label>
                <select id="proposalEditBrokerThree"
                        :disabled="!entity.is_billable || !entity.broker_two_id"
                        @change="entity.broker_three_commission = null"
                        :class="{'is-invalid': errors.broker_three_id}"
                        class="form-control form-control-sm"
                        v-model="entity.broker_three_id">
                    <option :value="null">[SELECIONE]</option>
                    <option v-for="b in brokers"
                            :key="b.id"
                            :disabled="b.removed || b.id === entity.broker_one_id"
                            :value="b.id">{{b.name}} {{b.last_name}}</option>
                </select>
                <field-messages :errors="errors.broker_three_id"/>
            </div>
            <div class="col-6 form-group col-md-2">
                <label for="proposalEditBrokerThreeCommission" :class="{required: !!entity.broker_three_id}">Comissão 3º Corretor</label>
                <input type="text"
                       id="proposalEditBrokerThreeCommission"
                       :class="{'is-invalid': errors.broker_three_commission}"
                       maxlength="5"
                       v-money="{precision: 1, decimal: ',', thousands: ''}"
                       placeholder="Ex: 20,0"
                       :disabled="!entity.is_billable || !entity.broker_three_id"
                       class="form-control form-control-sm t-r"
                       v-model="entity.broker_three_commission"/>
                <field-messages :errors="errors.broker_three_commission"/>
            </div>
        </div>
        <div class="row" :style="{
          visibility: isShowCommissionSampleButton ? 'visible' : 'hidden'
        }">
          <div class="col-12 t-r">
            <button type="button"
                    :disabled="is_saving_sample"
                    @click="saveCommissionSample"
                    class="btn btn-theme-1 btn-sm">Salva{{is_saving_sample ? 'ndo...' : 'r'}} Modelo</button>
          </div>
        </div>
    </div>
</template>

<script>
    import Autocomplete from '@/components/particles/Autocomplete'
    import CustomerDetail from './CustomerDetail'
    import {createNamespacedHelpers} from 'vuex'
    import dayjs from "dayjs";
    import StorageUtils from "../../utils/StorageUtils";
    const {mapGetters, mapActions} = createNamespacedHelpers('products');
    const proposalStore = createNamespacedHelpers('proposals');

    export default {
        name: "GeneralArea",
        components: {Autocomplete, CustomerDetail},
        props: {
            errors: {
                type: Object,
                default: {}
            },
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                price_type: true,
                desc: '',
                harvests: [],
                freight_types: [],
                proposal_commission_sample: {},
                is_saving_sample: false
            }
        },
        methods: {
            ...mapActions(['loadAll', 'loadCategories']),
            ...proposalStore.mapActions(['loadBrokers', 'loadCustomerAccounts']),
            returnValue(obj, isSeller) {
                if (isSeller) {
                    this.entity.seller_id = obj.id;
                    this.entity.seller = obj;
                    this.loadCustomerAccounts(obj.id);
                } else {
                    this.entity.buyer_id = obj.id;
                    this.entity.buyer = obj;
                    this.changeProduct();
                }

                this.searchCommissionSample()
            },
            itemPresentation(obj, val) {
                const regex = new RegExp(val, 'gi');
                const name = this.$appUtils.highlightText(obj.name, regex);
                const city_name = this.$appUtils.highlightText(obj.city.name, regex);
                const state_acronym = this.$appUtils.highlightText(obj.city.state.acronym, regex);

                let document = 'SEM DOCUMENTO';
                let doc_len = 0;

                if (obj.document) {
                    document = this.$appUtils.highlightText(this.$appUtils.formatDocument(obj.document), regex);
                    doc_len = obj.document.length;
                }

                return ['<div class="ellipsis">', name, '</div>', '<div style="font-size: .8em" class="ellipsis">', (doc_len === 14 ? 'CNPJ' : 'CPF'),': ', document, ' | CIDADE: ', city_name, '/', state_acronym, '</div>'].join('');
            },
            itemValuePresentation: obj => obj.name,
            changeProduct() {
                const prod = this.products.findById(this.entity.product_id);
                if (prod) this.entity.percentage_commission = prod.percentage_commission.replace('.', ',');

                if(this.entity.buyer_id && this.entity.product_id){

                    const params = new URLSearchParams({
                        customer_id: this.entity.buyer_id,
                        product_id: this.entity.product_id
                    });

                    this.$appHttp.get(`/v1/proposals/search/product_info?${params.toString()}`)
                        .then(({data}) => {
                            this.desc = data.description;
                            this.entity.special_condition = data.special_condition;
                            this.$set(this.entity, 'description', this.getDescription());
                        })
                        .catch(err => {
                            this.$snotify.warning('Aconteceu algum problema ao tentar carregar as descrições do produto.', this.$appStorage.getUser().name);
                            console.error(err);
                        });

                }
                this.searchCommissionSample()
            },
            getDescription() {
                let s = '';
                let q = this.entity.quantity;
                if(q !== undefined && q !== '') {
                    if(/,/gi.test(q)) q = q.split(',')[0];

                    s = q + ' ('+ q.extenso(false, true) +') TONELADA' + (q > 1 ? 's' : '') + ' DE ' + this.getProductName() + ', ';
                }
                if(this.desc) s += this.desc;
                return s.toUpperCase();
            },
            getProductName() {
                const product = this.products.findById(this.entity.product_id);
                if (product != null) return product.name;
                return '';
            },
            priceBlur() {
                if (!this.entity.id) {
                  const r = /^R\$\s(.+?)\s\(.+?\)/;
                  let p = this.entity.price_description;
                  p = p && r.test(p) ? p.replace(r, this.getPriceDescription()) : this.getPriceDescription();
                  this.$set(this.entity, 'price_description', p);
                }
            },
            quantityBlur() {
                let idxOf;
                let p = this.entity.description || '';
                p = (p !== '' && (idxOf = p.indexOf(',')) >= 0) ? this.getDescription() + p.substring(idxOf + 2, p.length) : this.getDescription();

                this.entity.description = p;
            },
            getPriceDescription() {
                let s = '';
                const p = this.entity.price;
                if(p && p !== '') s = 'R$ ' + p + ' ('+ p.extenso(true) +')';

                return s.toUpperCase();
            },
            initHarvests(year = new Date().getFullYear()) {
                let countYear = 2014;
                while (countYear < year + 3) {
                    this.harvests.push({
                        year: countYear,
                        disabled: countYear < year - 1
                    });
                    countYear++;
                }
            },
            loadFreightTypes() {
                this.$appHttp.get('/v1/proposals/load_freight_types')
                    .then(({data}) => this.freight_types = data)
                    .catch(err => {
                        this.$snotify.warning('Aconteceu algum problema ao tentar carregar os tipos de frete.', this.$appStorage.getUser().name);
                        console.error('Load freight types error.', err);
                    });
            },
            defineBillingDate(e) {
                const regex = /(\d{2})\/(\d{2})\/(\d{4})/;
                let date = regex.test(e.target.value) ? dayjs(e.target.value.replace(regex, '$3-$2-$1')) : null;

                if (date && !this.entity.billing_date) {
                    date = date.add(1, 'month').startOf('month');
                    while (date.day() === 0 || date.day() === 6) date = date.add(1, 'day');
                    this.entity.billing_date = date.format('DD/MM/YYYY');
                }
            },
            changeBillable() {
                this.entity.value_commission = 0;
                this.entity.percentage_commission = 0;
                this.entity.commission = null;
                this.entity.broker_one_id = null;
                this.entity.broker_one_commission = 0;
                this.entity.broker_two_id = null;
                this.entity.broker_two_commission = 0;
                this.entity.broker_three_id = null;
                this.entity.broker_three_commission = 0;
            },
            setCommissionSampleData(data) {
              Object.keys(data)
                  .filter(k => !['product_id', 'group_seller_id', 'group_buyer_id', 'id'].includes(k))
                  .forEach(k => {

                    let val;

                    if (/broker_(one|two|three)_commission$/.test(k)) {
                      val = this.$appUtils.formatNumber(data[k], 1)
                    } else if (/(percentage_commission)$/.test(k)) {
                      val = this.$appUtils.formatNumber(data[k], 2)
                    } else if (/(value_commission)$/.test(k)) {
                      val = this.$appUtils.formatMoney(data[k])
                    } else {
                      val = data[k]
                    }

                    data[k] = val
                    this.$set(this.entity, k, val)
                  })
            },
            async searchCommissionSample() {

              const {seller, buyer, product_id} = this.entity

              if (seller && buyer && product_id) {
                const p = new URLSearchParams()
                p.set('group_seller_id', seller.customer_group.id)
                p.set('group_buyer_id', buyer.customer_group.id)
                p.set('product_id', product_id)

                const url = ['/v1/proposal_commission_samples/search?', p.toString()]

                try {
                  const {data} = await this.$appHttp.get(url.join(''))

                  if (data.id) {
                    this.proposal_commission_sample = data
                    this.setCommissionSampleData(data)
                  } else {
                    this.proposal_commission_sample = {}
                  }

                } catch (err) {
                  this.$snotify.warning('Aconteceu algum problema ao tentar carregar examplo de comissão', this.$appStorage.getUser().name);
                  console.error('Proposal commission sample error.', err);
                }

              } else {
                this.proposal_commission_sample = {};
              }
            },
            async saveCommissionSample() {
              const url = ['/v1/proposal_commission_samples']

              const {seller, buyer, product_id,
                broker_one_id, broker_two_id, broker_three_id,
                broker_one_commission, broker_two_commission, broker_three_commission,
                value_or_percent_commission, value_commission,
                percentage_commission, commission, is_billable} = this.entity

              this.proposal_commission_sample = {
                ...this.proposal_commission_sample,
                group_seller_id: seller.customer_group.id,
                group_buyer_id: buyer.customer_group.id,
                product_id,
                broker_one_id,
                broker_two_id,
                broker_three_id,
                broker_one_commission,
                broker_two_commission,
                broker_three_commission,
                value_or_percent_commission,
                value_commission,
                percentage_commission,
                commission,
                is_billable
              }

              const isUpdate = !!(this.proposal_commission_sample || {}).id

              if (isUpdate) url.push('/', this.proposal_commission_sample.id)

              try {
                this.is_saving_sample = true

                const {data} = await this.$appHttp[isUpdate ? 'put' : 'post'](url.join(''), this.proposal_commission_sample)

                this.$snotify.success(`Exemplo de comissão ${isUpdate ? 'atualizado' : 'criado'} com sucesso!`, 'Exemplo');

                this.proposal_commission_sample = data
                this.setCommissionSampleData(data)
              } catch ({response}) {
                if (response.status === 422) {
                  Object.keys(response.data).forEach(k => {
                    this.$set(this.errors, k, response.data[k]);
                  });
                  this.$snotify.warning('Verifique os dados informados da área de comissão', 'Validação');
                } else {
                  this.$snotify.warning('Aconteceu algum problema ao tentar salvar o modelo de comissão', this.$appStorage.getUser().name);
                }

                console.error('Proposal commission sample error.', response);
              } finally {
                this.is_saving_sample = false
              }
            }
        },
        computed: {
            ...mapGetters({products: 'all', categories: 'categories'}),
            ...proposalStore.mapGetters(['brokers', 'seller_accounts']),
            isAdmin() {
                return StorageUtils.userIsProfile(['admin', 'admin_all'])
            },
            isShowCommissionSampleButton() {
              const {seller, buyer, product_id,
                broker_one_id, broker_two_id, broker_three_id,
                broker_one_commission, broker_two_commission, broker_three_commission,
                value_or_percent_commission, value_commission,
                percentage_commission, commission, is_billable} = this.entity

              if (!is_billable || !seller || !seller.customer_group || !buyer || !buyer.customer_group || !product_id) return false

              const currentJob = [
                seller.customer_group.id,
                buyer.customer_group.id,
                product_id,
                broker_one_id,
                broker_two_id,
                broker_three_id,
                broker_one_commission,
                broker_two_commission,
                broker_three_commission,
                value_or_percent_commission,
                value_commission,
                percentage_commission,
                commission,
                is_billable,
              ]

              const {
                id,
                group_seller_id,
                group_buyer_id,
                product_id: prod_id,
                broker_one_id: b_one_id,
                broker_two_id: b_two_id,
                broker_three_id: b_three_id,
                broker_one_commission: b_one_commission,
                broker_two_commission: b_two_commission,
                broker_three_commission: b_three_commission,
                value_or_percent_commission: v_p_commission,
                value_commission: v_commission,
                percentage_commission: p_commission,
                commission: c,
                is_billable: is_b} = this.proposal_commission_sample

              if (this.isAdmin && !id) return true

              const currentSample = [
                group_seller_id,
                group_buyer_id,
                prod_id,
                b_one_id,
                b_two_id,
                b_three_id,
                b_one_commission,
                b_two_commission,
                b_three_commission,
                v_p_commission,
                v_commission,
                p_commission,
                c,
                is_b,
              ]

              return currentJob.join('') !== currentSample.join('')
            }
        },
        mounted() {
            this.initHarvests();
            this.loadCategories();
            this.loadAll();
            this.loadBrokers()
                .then(brokers => {
                    if (!this.entity.id) this.$set(this.entity, 'broker_one_id', brokers.filter(b => !b.removed)[0].id);
                });
            this.loadFreightTypes();
        },
        watch: {
          entity: function () {
            const {clone} = this.$router.currentRoute.query;
            if (clone) this.searchCommissionSample()

            this.price_type = this.entity.price_type === 'value_defined'

            if (this.entity.price_type === 'value_undefined') {
              this.entity.price = null;
              //this.entity.price_description = '';
            }
          },
          "entity.price_type"() {
            this.price_type = this.entity && this.entity.price_type === 'value_defined'
          }
        }
    }
</script>
<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
